import Stack from '@mui/material/Stack';

import TableSkeleton from './table-skeleton';

function SkeletonLoading() {
  return (
    <Stack alignItems="center" display="flex" flexDirection="column">
      <TableSkeleton />
      <TableSkeleton />
      <TableSkeleton />
    </Stack>
  );
}

export default SkeletonLoading;
